/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext, useWatch } from 'react-hook-form';

export const useOrderTermsConditions = () => {
  const { retailer_info } = useSelector(
    (state) => state.retailerUsersReducer
  );

  const { setValue, control } = useFormContext();

  const updateTerms = useWatch({
    control,
    name: 'update_terms'
  });

  const contentValue = useWatch({
    control,
    name: 'terms_and_condition.terms_conditions_content'
  });

  const handleContentChange = useCallback((content) => {
    setValue('terms_and_condition.terms_conditions_content', content);
  }, [setValue]);

  const toggleUpdateTerms = useCallback(() => {
    setValue('update_terms', !updateTerms);
  }, [updateTerms, setValue]);

  return {
    retailerInfo: retailer_info,
    contentValue,
    updateTerms,
    handleContentChange,
    toggleUpdateTerms
  };
};
